
  export const style={
    inpuStyle:{
      colorInput:"#415264"
    },
    url:{
      urlClient:"https://zissou.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://storage-client-profile.appnoz.com.br/base-api/uploads/logos/profile_client/logoclient/116/Logo_Azul.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Zcoin/Zcoins"
    },
    teamName:{
      name:"Zissou"
    },
    hasToken: false,
    hostHeader: "zissou"
  }
